import { render, staticRenderFns } from "./GamePlay.vue?vue&type=template&id=773a445c&scoped=true"
import script from "./GamePlay.vue?vue&type=script&lang=ts"
export * from "./GamePlay.vue?vue&type=script&lang=ts"
import style0 from "./GamePlay.vue?vue&type=style&index=0&id=773a445c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a445c",
  null
  
)

export default component.exports